import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, ChevronRight, LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import './SupplierSidebar.css';

export default function SupplierSidebar({ onLogout }) {
  const { supplier } = useAuth();
  const location = useLocation();

  const handleNavClick = (path) => {
    if (location.pathname === path) {
      // Dispatch custom event to refresh data on current page
      window.dispatchEvent(new CustomEvent('navigationRefresh'));
    }
  };

  return (
    <aside className="supplier-sidebar">
      {/* Logo */}
      <div className="supplier-sidebar-logo">
        <img src="/chivita.png" alt="Chivita logo" className="supplier-sidebar-logo-img" />
        <div className="supplier-sidebar-logo-text">
          <span className="supplier-sidebar-logo-name">Laminate</span>
          <span className="supplier-sidebar-logo-sub">Artflow</span>
        </div>
      </div>

      {/* Nav */}
      <nav className="supplier-sidebar-nav">
        <p className="supplier-sidebar-section-label">Navigation</p>
        <NavLink
          to="/supplier/dashboard"
          onClick={() => handleNavClick('/supplier/dashboard')}
          className={({ isActive }) => `supplier-sidebar-link ${isActive ? 'active' : ''}`}
        >
          <LayoutDashboard size={18} />
          <span>Dashboard</span>
          <ChevronRight size={14} className="supplier-sidebar-link-arrow" />
        </NavLink>
      </nav>

      {/* Spacer */}
      <div style={{ flex: 1 }} />

      {/* User footer */}
      <div className="supplier-sidebar-footer">
        <div className="supplier-sidebar-user">
          <div className="supplier-sidebar-avatar">
            {supplier?.name?.charAt(0).toUpperCase()}
          </div>
          <div className="supplier-sidebar-user-info">
            <p className="supplier-sidebar-user-name">{supplier?.name}</p>
            <p className="supplier-sidebar-user-role">Supplier</p>
            {supplier?.email && <p className="supplier-sidebar-user-email">{supplier.email}</p>}
          </div>
        </div>
        <button className="supplier-sidebar-logout" onClick={onLogout} title="Sign out">
          <LogOut size={16} />
        </button>
      </div>
    </aside>
  );
}